import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";
import { ItemDescription } from "@coworker/apprestructured/src/shared/components/item-cards/ItemDescription/ItemDescription";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import styles from "../../../styles/common-styles.module.css";
import { ItemLocation } from "../ItemLocation/ItemLocation";
import { Spacer } from "../../Spacer/Spacer";
import { ReactNode } from "react";

interface ItemCardWithLocation {
  item: Item;
  location: string;
  extra?: ReactNode;
}

export const ItemCardWithLocation = ({
  item,
  location,
  extra,
}: ItemCardWithLocation) => {
  const showLocation = location && location !== "no_location";

  return (
    <ItemCard>
      <div className={styles["item-card-root-row"]}>
        <ItemImage imageUrl={item.imageUrl || item.smallImageUrl || ""} />

        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          <ItemNo itemNo={item.noFormatted} />
          <ItemDescription description={item.description || ""} />
          {showLocation && (
            <>
              <Spacer />
              <ItemLocation locationGridCode={location} />
            </>
          )}
          {extra}
        </div>
      </div>
    </ItemCard>
  );
};
